export function isSupportStorage () {
  if (window.localStorage) {
    window.localStorage.setItem('test_localstorage', 123);
    if (window.localStorage.getItem('test_localstorage') == 123) {
      window.localStorage.removeItem('test_localstorage');
      return true;
    }
    return false;
  }
  return false
}

export function getStorage (key) {
  if (!isSupportStorage()) return '';
  return window.localStorage.getItem(key);
}

export function setStorage (key, value) {
  if (!isSupportStorage()) return '';
  return window.localStorage.setItem(key, value);
}

export function removeStorage (key) {
  if (!isSupportStorage()) return '';
  return window.localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/common/localStorage.js